/* tslint:disable:max-line-length */
import { SegmentSpecificMessages } from '../../../types/types';

export const messages: SegmentSpecificMessages = {
    emailExplanation: 'Needed to send you your unique code',
    schoolName: '', // N/A
    step: {
        personalInfo: {
            subtitle: "Verify you're a current employee at an eligible company.",
            howDoesVerifyingWorkDetails: `"{companyName} has set up this special offer for all current employees of select companies.
            <br><br>
            {companyName} uses SheerID, a trusted partner, to verify that you are currently employed. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.`,
            tryAgain: {
                title: '',
                subtitle: '',
            },
        },
        docUpload: {
            howDoesVerifyingWorkDetails: `Document review is handled by SheerID, a trusted partner who specializes in verifying employees.
            <br><br>
            Documents are used only for verify your employment status is current and will be permanently deleted after review is finalized. They will not be shared with {companyName}`,
            uploadInstructions: 'Upload an official document that shows',
        },
    },
};
